import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import vehicleList from '../mock/vehicleList'
import { set } from 'lodash'
6
export interface VehicleState {
  vehicleList: typeof vehicleList
}

const initialState: VehicleState = {
  vehicleList: [],
}

export const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {
    setVehicleList: (state, action: PayloadAction<typeof vehicleList>) => {
      state.vehicleList = action.payload;
    },
    addVehicle: (state, action: PayloadAction<typeof vehicleList[0]>) => {
      state.vehicleList.unshift(action.payload);
    },
    removeVehicle: (state, action: PayloadAction<string>) => {
      state.vehicleList = state.vehicleList.filter(
        vehicle => vehicle._id !== action.payload
      );
    },
    updateVehicle: (state, action: PayloadAction<{ id: string; data: Partial<typeof vehicleList[0]> }>) => {
      const { id, data } = action.payload;
      state.vehicleList = state.vehicleList.map(vehicle =>
        vehicle._id === id ? { ...vehicle, ...data } : vehicle
      );
    },

    addServiceHistory: (
      state,
      action: PayloadAction<{ id: string; service: typeof vehicleList[0]['history'][0] }>
    ) => {
      const { id = '', service = {} as typeof vehicleList[0]['history'][0] } = action.payload;
      state.vehicleList = state.vehicleList.map(vehicle =>
        vehicle._id === id
          ? { ...vehicle, history: [...(vehicle.history ?? []), service] }
          : vehicle
      );
    },
    updateServiceHistory: (
      state,
      action: PayloadAction<{ id: string; serviceId: string; data: Partial<typeof vehicleList[0]['history'][0]> }>
    ) => {
      const { id = '', serviceId = '', data = {} } = action.payload;
      state.vehicleList = state.vehicleList.map(vehicle => {
        if (vehicle._id !== id) return vehicle;
        return {
          ...vehicle,
          history: (vehicle.history ?? []).map(service =>
            service._id === serviceId ? { ...service, ...data } : service
          ),
        };
      });
    },
    deleteServiceHistory: (
      state,
      action: PayloadAction<{ id: string; serviceId: string }>
    ) => {
      const { id = '', serviceId = '' } = action.payload;
      state.vehicleList = state.vehicleList.map(vehicle =>
        vehicle._id === id
          ? { ...vehicle, history: (vehicle.history ?? []).filter(service => service._id !== serviceId) }
          : vehicle
      );
    }
  },
})

export const { addVehicle, removeVehicle, updateVehicle, addServiceHistory, updateServiceHistory, deleteServiceHistory, setVehicleList } = vehicleSlice.actions

export const getVehicleList = (state: { vehicle: VehicleState }) => state.vehicle.vehicleList;
export default vehicleSlice;